// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"bc8f5c8a","188":"bb3f8f25","453":"d3ed2924","544":"997a4aa8","546":"25a68cd3","660":"e340b2f2"}[chunkId] + ".chunk.js";
};